import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/App/workspace/AppHitchMainH5/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "mint-ui/lib/indicator/style.css";
import _Indicator from "mint-ui/lib/indicator";
import "core-js/modules/es6.function.name";
import _defineProperty from "/var/lib/jenkins/App/workspace/AppHitchMainH5/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/var/lib/jenkins/App/workspace/AppHitchMainH5/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/App/workspace/AppHitchMainH5/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import Promise from 'pinkie-promise';
import authStore from '@/store/auth.js';
import MainStore from '@/store/userStore';
import UploadImgService, { PLATFORM_TYPE } from '@/utils/uploadImg.js';
import platformApi from '@/api/platformApi.js';
import MapHelper from "../map.js";
import toast from "../../components/toast/store.js";
import Store from "../../store";
import Storage from "../storage";
import Toast from "../../components/toast"; // import Cookie from '../../utils/cookie';

import tools from "../tools"; // eslint-disable-next-line import/no-cycle

import WalletService from "../../service/walletService"; // eslint-disable-next-line import/no-cycle

import VipService from "../../service/vipService";
import alipay from "../platformUtils/alipay";
import params from "../param";
var CB_PREFIX = 'hbcallback';
var cbIndex = 0;
var hideLoadingTimer;

var BrowserCallNative = /*#__PURE__*/function () {
  function BrowserCallNative() {
    _classCallCheck(this, BrowserCallNative);
  }

  _createClass(BrowserCallNative, null, [{
    key: "setPageTitle",
    value: function setPageTitle(_ref) {
      var title = _ref.title;

      if (title !== undefined) {
        document.title = title;
      }

      return Promise.resolve(true);
    }
  }, {
    key: "alertMessage",
    value: function alertMessage(data) {
      // TODO 使用通用msgStore进行控制
      // eslint-disable-next-line no-alert
      alert(data.message);
      return Promise.resolve(true);
    }
  }, {
    key: "toastMessage",
    value: function toastMessage(_ref2) {
      var message = _ref2.message;
      toast.showToast(message);
    }
  }, {
    key: "jumpTo",
    value: function jumpTo() {
      // TODO { name: 'about' / 'home' / 'feedback' }
      throw new Error('not implement');
    }
  }, {
    key: "goBack",
    value: function goBack() {
      window.history.back();
    }
  }, {
    key: "getCurrentLocation",
    value: function getCurrentLocation() {
      return MapHelper.getCurrentLocation();
    }
  }, {
    key: "getCityInfo",
    value: function getCityInfo() {
      return MapHelper.getCityInfo();
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.invalidToken();
    }
  }, {
    key: "showLoadingView",
    value: function showLoadingView() {
      throw new Error('not implement');
    }
  }, {
    key: "hideLoadingView",
    value: function hideLoadingView() {
      throw new Error('not implement');
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var cachedLoginInfo = this['.cached_login_info'];

      if (cachedLoginInfo && !tools.isPlainObject(cachedLoginInfo)) {
        return Promise.resolve(cachedLoginInfo);
      }

      var loginInfo = null;
      var loginResult = Storage.memory.login_result || Storage.getItem('login_result');
      loginInfo = loginResult || {};
      this['.cached_login_info'] = loginInfo;
      return Promise.resolve(loginInfo);
    }
  }, {
    key: "jumpToHome",
    value: function jumpToHome() {
      Store.state.router.replace({
        name: 'home'
      });
    }
  }, {
    key: "invalidToken",
    value: function invalidToken() {
      delete this['.cached_login_info'];
      Storage.removeItem('login_result');
      delete Storage.memory.login_result;
      authStore.reset();
      return Promise.resolve(true);
    }
  }, {
    key: "getTokenAndKey",
    value: function getTokenAndKey() {
      var locationHref = window.location.href;
      var urlToken = params.get('token', locationHref);
      var urlTicket = params.get('ticket', locationHref);
      var urlUserGuid = params.get('userGuid', locationHref);

      if (urlToken && urlTicket) {
        return Promise.resolve({
          token: urlToken,
          ticket: urlTicket,
          userGuid: urlUserGuid || ''
        });
      }

      if (urlToken) {
        return Promise.resolve({
          token: urlToken,
          userGuid: urlUserGuid || ''
        });
      }

      var res = MainStore.getUserStore() || {};
      return Promise.resolve(_objectSpread({}, res));
    }
  }, {
    key: "call",
    value: function call(data) {
      window.location.href = "tel:".concat(data.tel);
      return Promise.resolve(true);
    }
  }, {
    key: "scanQRCode",
    value: function scanQRCode() {
      if (/wifiwx/i.test(navigator.userAgent)) {
        return new Promise(function (resolve, reject) {
          if (window.WebViewJavascriptBridge) {
            if (!window.wxjsbInit) {
              window.WebViewJavascriptBridge.init();
              window.wxjsbInit = true;
            }

            window.WebViewJavascriptBridge.callHandler('scanQRCode', {}, function (res) {
              var result = typeof res === 'string' ? JSON.parse(res) : res;
              resolve(result.resultStr);
            });
          } else {
            reject(new Error('加载JsBridge失败'));
          }
        });
      }

      if (window.HBJsBridge) {
        cbIndex += 1;
        var cbName = CB_PREFIX + cbIndex;
        return new Promise(function (resolve, reject) {
          window[cbName] = function (res) {
            if (!res || typeof res !== 'string') {
              reject(new Error('没有返回结果或者结果不为String'));
            }

            var jsonRes = JSON.parse(res);

            if (jsonRes.success) {
              resolve(jsonRes.result);
            } else {
              reject(new Error(jsonRes.msg || '未知错误'));
            }
          };

          window.HBJsBridge.scanQR(cbName);
        });
      } // return Promise.resolve('http://c3x.me/?n=2100000032');


      throw new Error('not implement');
    }
  }, {
    key: "vibrate",
    value: function vibrate(opt) {
      if (navigator.vibrate) {
        navigator.vibrate(opt && opt.duration || 500);
      }

      return Promise.resolve();
    }
  }, {
    key: "chargeWallet",
    value: function chargeWallet(options) {
      return WalletService.chargeWalletAlipay(options).then(function (data) {
        alipay.pay(data.orderInfo);
      });
    }
  }, {
    key: "chargeDeposit",
    value: function chargeDeposit(options) {
      return WalletService.chargeDepositAlipay(options).then(function (data) {
        alipay.pay(data.orderInfo);
      });
    }
  }, {
    key: "chargeVip",
    value: function chargeVip(options) {
      return VipService.chargeVipAlipay(options).then(function (data) {
        alipay.pay(data.orderInfo);
      });
    }
  }, {
    key: "getNativePhoneNo",
    value: function getNativePhoneNo() {
      return Promise.resolve('');
    }
  }, {
    key: "callNative",
    value: function callNative(name, data) {
      if (!this[name]) {
        return Promise.reject(new Error("".concat(name, ": \u529F\u80FD\u6682\u65F6\u65E0\u6CD5\u4F7F\u7528")));
      }

      return this[name](data);
    }
    /**
     * * 链接跳转
     * @param {string} url跳转链接
     */

  }, {
    key: "navigateTo",
    value: function navigateTo(url) {
      window.location.href = url;
    }
    /**
     * 显示loading
     */

  }, {
    key: "showLoading",
    value: function showLoading() {
      _Indicator.open();
    }
    /**
     * 隐藏loading
     * @param {longint} delayTime 延迟隐藏毫秒数
     */

  }, {
    key: "hideLoading",
    value: function hideLoading(_ref3) {
      var delayTime = _ref3.delayTime;
      clearTimeout(hideLoadingTimer);
      hideLoadingTimer = setTimeout(function () {
        _Indicator.close();
      }, delayTime || 500);
    }
  }, {
    key: "callphotograph",
    value: function callphotograph(onlyUseCamera) {
      return new Promise(function (resolve, reject) {
        var fileInput = document.querySelector('.outside-file-input');

        if (fileInput) {
          document.body.removeChild(fileInput);
        }

        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';

        if (onlyUseCamera) {
          fileInput.capture = 'camera';
        }

        if (!fileInput.classList.contains('outside-file-input')) {
          fileInput.classList.add('outside-file-input');
        }

        var callback = function callback() {
          if (!fileInput.files || fileInput.files.length < 1) {
            reject();
            return;
          }

          var filetype = fileInput.files[0].type;
          var fileSize = fileInput.files[0].size;
          var reg = /^(image)/;

          if (!reg.test(filetype)) {
            Toast.show('请选择照片').catch(function (v) {
              return reject(v);
            });
            return;
          }

          var reader = new FileReader();
          reader.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var scale, compressImg;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    scale = fileSize > 500 * 1024 ? 500 * 1024 / fileSize : 1;
                    _context.next = 4;
                    return UploadImgService.imgCompress(reader.result, scale, filetype);

                  case 4:
                    compressImg = _context.sent;
                    resolve(compressImg.replace(/data:image\/.*;base64,/, ''));
                    _context.next = 12;
                    break;

                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                    Toast.show('图片上传发生错误,请稍后重试').catch(function (v) {
                      return reject(v);
                    });
                    reject(_context.t0);

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 8]]);
          }));
          reader.readAsDataURL(fileInput.files[0]);
        };

        fileInput.onchange = callback;
        fileInput.click();
        document.body.appendChild(fileInput);
      });
    }
  }, {
    key: "chooseImageAndUploadImage",
    value: function () {
      var _chooseImageAndUploadImage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(Params) {
        var beforeUpload, afterUpload, onlyUseCamera, relFile, imageUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Params) {
                  beforeUpload = Params.beforeUpload;
                  afterUpload = Params.afterUpload;
                }

                onlyUseCamera = !!(Params && Params.onlyUseCamera);
                _context2.next = 4;
                return this.callphotograph(onlyUseCamera);

              case 4:
                relFile = _context2.sent;

                if (beforeUpload) {
                  beforeUpload();
                }

                _context2.prev = 6;
                _context2.next = 9;
                return platformApi.uploadImage({
                  file: relFile || '',
                  image: 40,
                  type: PLATFORM_TYPE.H5
                });

              case 9:
                imageUrl = _context2.sent;

                if (afterUpload) {
                  afterUpload();
                }

                return _context2.abrupt("return", imageUrl.url);

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](6);

                if (afterUpload) {
                  afterUpload();
                }

                return _context2.abrupt("return", '');

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 14]]);
      }));

      function chooseImageAndUploadImage(_x) {
        return _chooseImageAndUploadImage.apply(this, arguments);
      }

      return chooseImageAndUploadImage;
    }()
  }, {
    key: "chooseMedia",
    value: function chooseMedia() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$mediaType = options.mediaType,
          mediaType = _options$mediaType === void 0 ? 'image/*' : _options$mediaType,
          _options$onlyUseCamer = options.onlyUseCamera,
          onlyUseCamera = _options$onlyUseCamer === void 0 ? false : _options$onlyUseCamer;
      return new Promise(function (resolve, reject) {
        var fileInput = document.querySelector('.outside-file-input');

        if (fileInput) {
          document.body.removeChild(fileInput);
        }

        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = mediaType;

        if (onlyUseCamera) {
          fileInput.capture = 'camera';
        }

        if (!fileInput.classList.contains('outside-file-input')) {
          fileInput.classList.add('outside-file-input');
        }

        fileInput.onchange = function () {
          var file = fileInput.files[0];

          if (!file) {
            reject(new Error('没有选择文件'));
          }

          var filetype = file.type;
          var fileSize = file.size;
          resolve({
            file: file,
            filetype: filetype,
            fileSize: fileSize
          });
        };

        fileInput.click();
        document.body.appendChild(fileInput);
      });
    }
  }]);

  return BrowserCallNative;
}();

export { BrowserCallNative as default };